import { type FC, type ReactNode } from 'react'
import classNames from 'classnames'

interface VocabularyNoticeProps {
  icon: string
  children: ReactNode
}

export const VocabularyNotice: FC<VocabularyNoticeProps> = ({ icon, children }) => (
  <div className='d-flex align-items-center zocks-gap-0.75 paragraph-medium zocks-text-gray-900 zocks-bg-color-gray-100 border zocks-border-color-gray-200 rounded-3 zocks-px-0.75 py-3'>
    <i className={classNames('bi', icon, 'fs-6 flex-shrink-0')} aria-hidden='true' />
    <span>{children}</span>
  </div>
)
